import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import { CookieBannerSelectionOption } from './CookieBannerSelectionOption';

const messages = defineMessages({
  necessary: {
    id: 'cookie-banner.checkboxes.label.necessary',
    defaultMessage: 'Necessary',
  },
  marketingAndAnalytics: {
    id: 'cookie-banner.checkboxes.label.marketing-analytics',
    defaultMessage: 'Analytics',
  },
  advertising: {
    id: 'cookie-banner.checkboxes.label.marketing',
    defaultMessage: 'Marketing',
  },
});

class CookieBannerSelection extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    selection: PropTypes.exact({
      necessary: PropTypes.bool.isRequired,
      marketingAndAnalytics: PropTypes.bool.isRequired,
      advertising: PropTypes.bool.isRequired,
    }).isRequired,
    onChange: PropTypes.func.isRequired,
  };

  state = {
    checkboxes: {
      necessary: {
        key: 'necessary',
        disabled: true,
        checked: this.props.selection.necessary,
        label: messages.necessary,
      },
      marketingAndAnalytics: {
        key: 'marketingAndAnalytics',
        disabled: false,
        checked: this.props.selection.marketingAndAnalytics,
        label: messages.marketingAndAnalytics,
      },
      advertising: {
        key: 'advertising',
        disabled: false,
        checked: this.props.selection.advertising,
        label: messages.advertising,
      },
    },
  };

  onStateUpdate = () => {
    this.props.onChange(this.getSelection(this.state.checkboxes));
  };

  onCheckboxChange = changeEvent => {
    const { name } = changeEvent.target;
    this.setState(
      prevState => ({
        checkboxes: {
          ...prevState.checkboxes,
          [name]: {
            ...prevState.checkboxes[name],
            checked: !prevState.checkboxes[name].checked,
          },
        },
      }),
      this.onStateUpdate
    );
  };

  getSelection = checkboxes => {
    return Object.keys(checkboxes)
      .map(key => checkboxes[key]) // turn to array
      .reduce((acc, { key, checked }) => {
        return {
          ...acc,
          [key]: checked,
        };
      }, {});
  };

  renderCheckbox = key => {
    const { disabled, checked, label } = this.state.checkboxes[key];
    return (
      <CookieBannerSelectionOption
        key={key}
        name={key}
        disabled={disabled}
        checked={checked}
        onChange={this.onCheckboxChange}
        label={this.props.intl.formatMessage(label)}
      />
    );
  };

  render() {
    return Object.keys(this.state.checkboxes).map(this.renderCheckbox);
  }
}

export default injectIntl(CookieBannerSelection);



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/components/cookieBanner/CookieBannerSelection.js